module.exports = __webpack_public_path__ + "img/cartoonHead2-1.b2236009.png";